import Vue from 'vue';
import axios from 'axios';
import cryptoJs from 'crypto-js'
import ElementUI from 'element-ui';
var $base64 = require("js-base64").Base64;
import AES from './encryption';
export  function getToken_http(){
    var data_ ={
        AppName:'ArtPlatform',
        AccessKeyId:'e10adc3949ba59abbe56e057f20f883e',
        Env:'web',
        Ver:'1.0',
    }
    let url_t = `${process.env.API_URI}/api/app/account/getToken`
    data_['Timestamp'] = +new Date()
    let keys = AES.generatekey('0',data_.Timestamp);
    let encrypts = AES.encrypt(JSON.stringify({'uid':Number($base64.decode(window.localStorage.getItem('uid-web')))}),keys);
    axios.post(url_t+HmacSHA256(data_,url_t),{data:encrypts},{headers: {'Content-Type':'application/json;charset=utf-8',"userToken":'0'}}
    ).then(response => {
        let res = {data:JSON.parse(AES.decrypt(response.data.data,keys))}
        let v = res.data
        if (v.code == 0) {
            window.localStorage.setItem('userToken-web',$base64.encode(v.data.token));
            window.localStorage.setItem('tokenExpiryTime-web',$base64.encode((+new Date()+(v.data.tokenExpiryTime*1000))));
            // ElementUI.Message({
            //     message: '令牌更新成功',
            //     type: 'success'
            // })
        }
    })
}
export function HmacSHA256(obj,url){
    var oll = sha256(obj,url)
    let map = new Map();
    let prm = Object.keys(obj).map(function(k) {
      map.set(k, obj[k]);
      return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
      }).join('&');
      var str = '?'+prm+'&Signature='+oll
      return str
    }

export function sha256(obj,url){
    if(!$base64.decode(window.localStorage.getItem('secretKey-web'))) return 0;
    let map = new Map();
    let prm = Object.keys(obj).map(function(k) {
        map.set(k, obj[k]);
        return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
      }).join('&');
      var _prm = 'POST\n'+prm;
      var esa_prm = cryptoJs.HmacSHA256(_prm,$base64.decode(window.localStorage.getItem('secretKey-web'))).toString();
      var result = $base64.encode(String(esa_prm));
      return result
    }

export default {
    getToken_http
}


// WEBPACK FOOTER //
// ./src/lib/getToken.js